import script from "./player-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./player-menu.vue?vue&type=script&setup=true&lang=ts"

import "./player-menu.vue?vue&type=style&index=0&id=727d9c7a&scoped=true&lang=css"

import exportComponent from "/Users/boubacardiallo/www/HomeDev/5050/mobile_app_50_50/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727d9c7a"]])

export default __exports__